import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { AppHeader } from '../AppHeader';
import { ErrorBoundary } from '../ErrorBoundaries/ErrorBoundary';
import { Notification } from 'components/Notification/Notification';
import s from './App.scss';
import { GlobalStyles } from './GlobalStyles';
import { MultiProductApp } from './MultiProductApp';
import { BreakpointProvider } from 'providers/BreakpointProvider';
import { StickyHeaderHeightProvider } from 'providers/StickyHeaderHeightProvider';
import { useAppLoaded } from '../../hooks/useAppLoaded';
import { Footer } from '../Footer/Footer';
import { ScrollRef } from 'components/ScrollRef/ScrollRef';

export interface AppProps {
  rootStore: RootStore;
}

export const AppComponent: React.FC<AppProps> = ({ rootStore }) => {
  const { theme } = usePageModeContext();
  useAppLoaded(rootStore.appStore);

  const { currentStep } = rootStore.appStore;
  return (
    <>
      <GlobalStyles />
      <>
        <BreakpointProvider>
          <StickyHeaderHeightProvider>
            <AppHeader currentStep={currentStep} />
            <ErrorBoundary>
              <div className={classNames(s.mainContent, theme)}>
                <Notification />
                <ScrollRef />
                <MultiProductApp />
                <Footer />
              </div>
            </ErrorBoundary>
          </StickyHeaderHeightProvider>
        </BreakpointProvider>
      </>
    </>
  );
};

export const App = withInjectedRootStore(observer(AppComponent));
